import { useState } from 'react';

let globalId = 0;

export function useNotification() {
  const [notifications, setNotifications] = useState([]);

  function notify(message, type = 'info', duration = 2500) {
    const id = ++globalId;

    // Remove any existing pending notifications when a new one comes
    setNotifications(prev => {
      const filtered = type === 'pending'
        ? prev.filter(n => n.type !== 'pending')
        : prev.filter(n => n.type !== 'pending');
      return [...filtered, { id, message, type, exiting: false }];
    });

    const autoDuration = type === 'error' ? 3500 : type === 'success' ? 2000 : duration;

    if (autoDuration > 0) {
      // Start exit animation before removing
      setTimeout(() => {
        setNotifications(prev => prev.map(n => n.id === id ? { ...n, exiting: true } : n));
      }, autoDuration - 300);

      setTimeout(() => {
        setNotifications(prev => prev.filter(n => n.id !== id));
      }, autoDuration);
    }
    return id;
  }

  function removeNotification(id) {
    setNotifications(prev => prev.map(n => n.id === id ? { ...n, exiting: true } : n));
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 300);
  }

  function notifySuccess(message) { return notify(message, 'success'); }
  function notifyError(message) { return notify(message, 'error'); }
  function notifyPending(message) { return notify(message, 'pending', 0); }
  function notifyInfo(message) { return notify(message, 'info'); }

  return { notifications, notify, removeNotification, notifySuccess, notifyError, notifyPending, notifyInfo };
}
